import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useMerchant } from "../../../../hooks/useMerchant";
import { useTRPC } from "../../../../trpc/client";

export function useRetrySettlement(onSuccess: () => void, onError: () => void) {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const { merchant } = useMerchant();

  const retrySettlementMutation = useMutation({
    ...trpc.settlements.retry.mutationOptions(),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: trpc.settlements.list.queryKey(),
      });
      onSuccess();
    },
    onError,
  });

  const retrySettlement = (
    date: string,
    cycle: string,
    callbacks?: { onSettled?: () => void }
  ) => {
    if (!merchant?.id) return;

    retrySettlementMutation.mutate(
      {
        rentalsMerchantId: merchant.id,
        date,
        cycle,
      },
      {
        onSettled: () => callbacks?.onSettled?.(),
      }
    );
  };

  return { retrySettlement };
}
